import {useCallback, useEffect, useRef} from "react";
import {useMapContext} from "base/map";

export function useBaseLayerAutoControl() {
    let mapObjectRef = useRef(null);
    let baseLayerRef = useRef(null);

    const {baseLayers, selectedBaseLayer} = useMapContext();

    const listenBaseLayerZoomAuto = useCallback(() => {
        const zoom = mapObjectRef.current.getZoom();
        const autoZoomConfig = selectedBaseLayer.config;
        const currentLayerConfig = autoZoomConfig.find(
            layerConfig => zoom <= layerConfig.maxZoom
        );
        if (currentLayerConfig) {
            setBaseLayer(
                baseLayers.find(layer => currentLayerConfig.code === layer.code)
            );
        } else {
            setBaseLayer(baseLayers[0]);
        }
    }, [selectedBaseLayer, baseLayers]);

    useEffect(() => {
        if (mapObjectRef.current) {
            mapObjectRef.current.off("zoomend", listenBaseLayerZoomAuto);
            if (selectedBaseLayer?.code === "auto") {
                mapObjectRef.current.on("zoomend", listenBaseLayerZoomAuto);
                listenBaseLayerZoomAuto();
            } else {
                setBaseLayer(selectedBaseLayer);
            }
        }

        // Función de limpieza del efecto
        return () => {
            if (mapObjectRef.current) {
                mapObjectRef.current.off("zoomend", listenBaseLayerZoomAuto);
            }
        };
    }, [selectedBaseLayer, listenBaseLayerZoomAuto, baseLayers]);

    const setBaseLayer = baseLayer => {
        if (mapObjectRef.current) {
            if (baseLayerRef.current) {
                mapObjectRef.current.removeLayer(baseLayerRef.current);
            }
            console.log("CARTO >> Setting base layer", {baseLayer});
            if (baseLayer) {
                if (baseLayer.isWms) {
                    baseLayerRef.current = L.tileLayer
                        .wms(baseLayer.url, {
                            ...baseLayer.options,
                        })
                        .addTo(mapObjectRef.current);
                } else {
                    baseLayerRef.current = L.tileLayer(baseLayer.url, {
                        ...baseLayer.options,
                    }).addTo(mapObjectRef.current);
                }
            }
        }
    };

    const addBaseLayerZoomControl = map => {
        mapObjectRef.current = map;
    };

    return {addBaseLayerZoomControl};
}
